import React, { HTMLAttributes, CSSProperties, forwardRef } from 'react';
import { IconDefinition } from './types';
import * as styles from './styles';
import { cx } from '../customEmotion';

const svgBaseProps = {
	width: '1em',
	height: '1em',
	fill: 'currentColor',
	['aria-hidden']: true,
	focusable: 'false',
};

export interface IconProps extends HTMLAttributes<SVGSVGElement> {
	className?: string;
	style?: CSSProperties;
	icon: IconDefinition;
	viewBox?: string;
	spin?: boolean;
	size?: number;
	/**
	 * css transform rotate(???deg)
	 */
	rotate?: number;
}

const Icon = forwardRef<SVGSVGElement, IconProps>((
	{
		/**
		 * @ignore
		 */
		children,
		className,
		icon,
		viewBox,
		style,
		spin,
		rotate,
		size,
		...props
	},
	ref
) => {
	if (!icon) {
		return null;
	}

	const svgStyle: CSSProperties = {...style, fontSize: `${size}em`};

	if (rotate) {
		const transform = `rotate(${rotate}deg)`;
		svgStyle.msTransform = transform;
		svgStyle.transform = transform;
	}

	const svgProps = {
		...props,
		...svgBaseProps,
		className: spin ? cx(styles.spin, className) : className,
		style: svgStyle,
		viewBox: viewBox || icon.definition.viewBox,
	};

	if (!svgProps.viewBox) {
		delete svgProps.viewBox;
	}

	return (
		<svg
			{...svgProps}
			ref={ref}
		>
			<path d={icon.definition.pathData} />
		</svg>
	);
});

Icon.defaultProps = {
	size: 1,
};

export default Icon;
